import { render, staticRenderFns } from "./SetOdometer.vue?vue&type=template&id=2f396d34"
import script from "./SetOdometer.vue?vue&type=script&lang=ts"
export * from "./SetOdometer.vue?vue&type=script&lang=ts"
import style0 from "./SetOdometer.vue?vue&type=style&index=0&id=2f396d34&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports